<div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading booking slots">
  <span class="spinner-border" aria-hidden="true"></span>
</div>
<div class="example-container mat-elevation-z8" [hidden]="isLoading">
  <table mat-table [dataSource]="dataSource">
    <!-- Date/Time Column -->
    <ng-container matColumnDef="dateTime" sticky>
      <th mat-header-cell *matHeaderCellDef>DATE</th>
      <td mat-cell *matCellDef="let element" class="date-time-label"
        style="border-bottom: 1px solid #e0e0e0 !important; background: #FFA07A;">
        {{getFormattedTime(element.dateTime)}} </td>
    </ng-container>


    <ng-container matColumnDef="{{column?.dateFormat}}" *ngFor="let column of dayColumnsObj">
      <th mat-header-cell *matHeaderCellDef>
        <div>{{getDayHeader(column.dateTime)}}</div>
        <div>{{getWeekDay(column.dateTime)}}</div>
      </th>

      <td mat-cell *matCellDef="let element" id="dt{{element[column?.dateFormat]?.default?.uniqueId}}" class="slot-data"
        [ngClass]="getSlotClass(element[column?.dateFormat]?.default,column?.dateFormat)"
        (mousedown)="handleMouseDown(element, column?.dateFormat, $event, 'default')"
        (dblclick)="handleDoubleClick(element, column?.dateFormat, $event, 'default')"
        [matMenuTriggerFor]="canOpenMenu(element[column?.dateFormat]?.default) ? slotMenu : null"
        [matMenuTriggerData]="{ slot: element[column?.dateFormat]?.default }" #menuTrigger="matMenuTrigger"
        (menuOpened)="slotMenuTrigger = menuTrigger">

        <div *ngIf="element[column?.dateFormat]?.default" class="slot-content">
          <!-- Booked or Partially Booked -->
          <div *ngIf="element[column?.dateFormat]?.default?.bookedSlots?.length > 0
            && !element[column?.dateFormat]?.default?.isPartiallyBooked" class="slot-info">
            <div class="slot-scroll-limiter">
              <div *ngFor="let booked of element[column?.dateFormat]?.default?.bookedSlots">
                <div class="customer-name">{{booked.customerName}}</div>
                <div class="price">{{rupeeSign}} {{booked.price}}</div>
              </div>
            </div>
          </div>

          <div *ngIf="element[column.dateFormat]?.default?.bookedSlots?.length > 0 &&
            element[column.dateFormat]?.default?.isPartiallyBooked
            && !isPastSlot(
              column.dateFormat,
              element[column.dateFormat]['default'].bookedSlots[0]?.startTime
            )" class="slot-info">
            <div class="price">Last
              {{remainingSlots(element[column.dateFormat]?.default?.bookedSlots)}} Slots<br />{{rupeeSign}}
              {{element[column.dateFormat]?.default?.bookedSlots[0].price}}</div>
          </div>

          <div *ngIf="element[column.dateFormat]?.default?.bookedSlots?.length > 0 &&
            element[column.dateFormat]?.default?.isPartiallyBooked
            && isPastSlot(
              column.dateFormat,
              element[column.dateFormat]['default'].bookedSlots[0]?.startTime
            )" class="slot-info">
            <div class="customer-name"> {{ element[column.dateFormat]['default'].bookedSlots[0]?.customerName }}</div>
            <div class="price">
              {{ rupeeSign }} {{ element[column.dateFormat]['default'].bookedSlots[0]?.price
              }}
            </div>
          </div>


          <!-- Available -->
          <div *ngIf="element[column?.dateFormat]?.default?.availableSlots?.length > 0
                      && !element[column?.dateFormat]?.default?.isPartiallyBooked
                      && !element[column?.dateFormat]?.default?.isBooked" class="slot-info">
            <div class="price">
              {{ rupeeSign }} {{ element[column.dateFormat]['default'].availableSlots[0]?.price
              }}
            </div>
          </div>

          <!-- Default Label -->
          <div *ngIf="!element[column?.dateFormat]?.default?.availableSlots?.length
                      && !element[column?.dateFormat]?.default?.bookedSlots?.length" class="slot-info">
            {{element[column?.dateFormat]?.default?.displayLabel}}
          </div>
        </div>

        <!-- Mat-Menu for Slot Actions -->
        <mat-menu #slotMenu="matMenu">
          <button mat-menu-item *ngIf="element[column?.dateFormat]?.default?.bookedSlots?.length > 0"
            (click)="showDetails(element, column?.dateFormat, $event, 'default')">Show Details</button>

          <button mat-menu-item *ngIf="element[column?.dateFormat] && !element[column?.dateFormat]['default']?.isSelected && (element[column?.dateFormat]?.default?.availableSlots?.length > 0 || element[column?.dateFormat]?.default?.isPartiallyBooked)
                          && element[column?.dateFormat]?.default?.bookedSlots?.length != selectedProduct?.capacityPerVenue
                          &&  !isPastSlot(
                                        column.dateFormat,
                                        element[column.dateFormat]['default'].bookedSlots[0]?.startTime
                                      )" (click)="addToCart(element, column?.dateFormat, $event, 'default')">Add to
            Cart</button>

          <button mat-menu-item *ngIf="element[column?.dateFormat]?.default?.isSelected && !isPastSlot(
            column.dateFormat,
            element[column.dateFormat]['default'].bookedSlots[0]?.startTime
          )" (click)="removeFromCart(element, column?.dateFormat, $event, 'default')">Remove from Cart</button>
        </mat-menu>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="{{column?.dateFormat}}" *ngFor="let column of dayColumnsObj">
      <th mat-header-cell *matHeaderCellDef>
        <div>{{getDayHeader(column.dateTime)}}</div>
        <div>{{getWeekDay(column.dateTime)}}</div>
      </th>
      <td mat-cell *matCellDef="let element" id="dt{{element[column?.dateFormat]?.uniqueId}}" (dblclick)="onDblClick()"
        (click)="onSingleClick(element, column?.dateFormat, $event)" class="slot-data" [ngClass]="element[column?.dateFormat] && element[column?.dateFormat].isAvailable ? 'available-slot':
                    (element[column?.dateFormat] && element[column?.dateFormat].isSelected ? 'selected-slot':
                    (element[column?.dateFormat] && element[column?.dateFormat].isBooked ? 'booked-slot': ''))">
        <div *ngIf="element[column?.dateFormat]">
          <div *ngIf="element[column?.dateFormat].isBooked">
            <div>{{element[column?.dateFormat].customerName}}</div>
            {{rupeeSign}} {{element[column?.dateFormat].price}}
          </div>
          <div *ngIf="element[column?.dateFormat].isAvailable || element[column?.dateFormat].isSelected">
            {{rupeeSign}} {{element[column?.dateFormat].price}}
          </div>
          <div
            *ngIf="!element[column?.dateFormat].isAvailable && !element[column?.dateFormat].isBooked && !element[column?.dateFormat].isSelected">
            {{element[column?.dateFormat].displayLabel}}
          </div>
        </div>
      </td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="columnData; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnData;"></tr>
  </table>
</div>
